import { render, staticRenderFns } from "./RoutePlanPassengersSettings.vue?vue&type=template&id=2e7d83a8&scoped=true"
import script from "./RoutePlanPassengersSettings.vue?vue&type=script&lang=js"
export * from "./RoutePlanPassengersSettings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e7d83a8",
  null
  
)

export default component.exports